import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectObjectSearchState } from '../../../../store/selectors';
import { ObjectSearchState, } from '../../../../store/objectSearch/ObjectSearchState';
import { MessageDialog } from '@sas/nova-commons/components/MessageDialog';
import { useI18n } from '../../../../locale/I18nContext';
export const FeatureErrorDialogBase = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const localize = useI18n();
    const message = ((_b = (_a = props.featureErrorState) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b.join('\n\n')) || '';
    return (_jsx(MessageDialog, { type: ((_c = props.featureErrorState) === null || _c === void 0 ? void 0 : _c.type) || 'error', isOpen: props.featureInErrorState !== undefined, title: localize({
            key: ((_d = props.featureInErrorState) === null || _d === void 0 ? void 0 : _d.type) === 'area'
                ? 'FeatureErrorDialog.title.area.txt'
                : 'FeatureErrorDialog.title.route.txt',
        }), text: ((_e = props.featureErrorState) === null || _e === void 0 ? void 0 : _e.type) === 'information'
            ? message
            : localize({
                key: ((_f = props.featureInErrorState) === null || _f === void 0 ? void 0 : _f.type) === 'area'
                    ? 'FeatureErrorDialog.text.area.txt'
                    : 'FeatureErrorDialog.text.route.txt',
            }), detailText: message, firstAction: {
            text: localize({ key: 'FeatureErrorDialog.close.txt' }),
            onPress: () => {
                props.actions.update(props.id, {
                    featureErrorState: undefined,
                });
            },
        } }));
};
export const FeatureErrorDialog = connect((state, props) => {
    var _a;
    const { features, featureErrorState } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const featureInErrorState = featureErrorState !== undefined && featureErrorState.index >= 0
        ? features === null || features === void 0 ? void 0 : features[featureErrorState.index]
        : undefined;
    return { featureInErrorState, featureErrorState };
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(FeatureErrorDialogBase);
